import { getModelCapability } from '@inference.engine/model-registry/web';
import { SUPPORTED_IMAGE_MODELS } from '../ui/ChatOptions/ImageGeneration/ImageGenerationOptions.types';
import { SUPPORTED_VIDEO_MODELS } from '../ui/ChatOptions/VideoGeneration/VideoGenerationOptions.types';

/**
 * Resolves a user-facing display label for a model id, used by the AI model
 * selector chip so it shows names (e.g. "GPT-5.5 pro", "Nano Banana 2",
 * "Runway Gen 4.5") rather than raw ids (`gpt-5.5-pro`, …).
 *
 * Label sources, in priority order:
 *  1. Text/chat models — `@inference.engine/model-registry` (single source of
 *     truth for chat-model labels).
 *  2. Image / video generation models — the frontend `SUPPORTED_*_MODELS` lists,
 *     since media models are intentionally absent from the registry.
 *
 * Falls back to the raw id for any unknown model so the chip never renders empty.
 */
export function getModelDisplayLabel(modelId: string): string {
  const capability = getModelCapability(modelId);
  if (capability) return capability.label;

  const imageModel = SUPPORTED_IMAGE_MODELS.find((m) => m.value === modelId);
  if (imageModel) return imageModel.label;

  const videoModel = SUPPORTED_VIDEO_MODELS.find((m) => m.value === modelId);
  if (videoModel) return videoModel.label;

  return modelId;
}
